<mat-card class="slidecontent">
  <div class="pophead">
    <button mat-icon-button (click)="closedocumentDetail(closeDetail)" (click)="tabs.selectedIndex=0">
      <mat-icon>arrow_forward</mat-icon>
    </button>

    <div class="">
      <button (click)="closedocumentDetail(closeDetail)" (click)="tabs.selectedIndex=0" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>

  </div>


  <div class="detailtabs">
    <mat-tab-group #tabs animationDuration="0ms" (selectedTabChange)="onTabClick($event)">
      <mat-tab label="Detail">       
        <div class="detail">

          <div class="placeholder">
           <label>Placeholder Name</label>
            <div class="inputHolder">
              <input type="text" class="form-control"  placeholder="Add Placeholder Name" [(ngModel)]="placeholderName" >

              <!-- <mat-form-field class="" appearance="fill">
                <mat-label>Placeholder Name</mat-label>
                <input matInput placeholder="Add Placeholder Name" [(ngModel)]="placeholderName">
              </mat-form-field>  -->
            
              <button mat-icon-button color="primary" (click)="savePlaceHolderName()">
               <mat-icon>save</mat-icon>
              </button>
            </div>
  
          </div>  

        

          <div class="placeholder">

          <!-- <mat-form-field class="" appearance="fill" *ngIf="projectName!=''">
            <mat-label>Project</mat-label>
            <input matInput placeholder="" value="{{projectName}}" (blur)="onChange($event.target.value)">
          </mat-form-field>  -->
          <label>Project Name</label>
          <div class="inputHolder">
              <input type="text" placeholder="Project Name" value="{{projectName}}" (blur)="onChange($event.target.value)" >
          </div>
          


          </div>
        
       


         <div class="docactions" >
            <div class="act" *ngIf="formType!=3">
              <button [disabled]=!showAllDownloadButton (click)="downloadSelectedFile()" mat-icon-button color="primary">
                <mat-icon>cloud_download</mat-icon>
              </button>
              <span *ngIf="showAllDownloadButton" >Download</span>
            </div>

            <div class="act" *ngIf="showLocalPanel">
              <button mat-icon-button color="primary" [routerLink]="'/esignature/first'">
                <mat-icon>format_shapes</mat-icon>
              </button>
              <span>Form Editor</span>
            </div>

            <div class="act" *ngIf="showLocalPanel">
              <button mat-icon-button color="primary" [routerLink]="'/request/signature'">
                <mat-icon>create</mat-icon>
              </button>
              <span>Sign</span>
            </div>

            <div class="act" *ngIf="showLocalPanel">
              <button mat-icon-button color="primary" (click)="shareFiles(shareFile)">
                <mat-icon>share</mat-icon>
              </button>
              <span>Email</span>
            </div>

            <div class="act" *ngIf="placeholderType!=2 && formType!=3">
              <input #Input hidden="true" type="file" onclick="this.value=null" (change)="UploadFile($event)"/>
              <button mat-icon-button color="primary" matTooltip="Upload" (click)="Input.click()" matTooltipClass="tooltip">               
                <mat-icon>cloud_upload</mat-icon>               
              </button>
              <span>Upload</span>
            </div>          

            <div class="act" *ngIf="formType!=3">
              <button [disabled]=!mergeButton (click)="mergeSelectedFile()" mat-icon-button color="primary">
                <mat-icon>merge</mat-icon>
              </button>
              <span *ngIf="mergeButton" >Merge</span>
            </div>

            <!-- <div class="act" *ngIf="formType!=3">
              <button [disabled]=!showAllDownloadButton (click)="deleteSelectedFile()" mat-icon-button color="primary">
                <mat-icon>delete</mat-icon>
              </button>
              <span>Delete</span>
            </div> -->

          </div>


          <div class="history">
            <div class="title">
              <h3>Documents</h3>
              <span class="count">{{uploadHistory.length}}</span>
            </div>
            <div class="historylist" *ngFor="let history of uploadHistory">
              <div class="list">
                <mat-checkbox color="primary" [checked]="history.checked" (change)="checkUploadHistoryElement($event, history)"></mat-checkbox>
                <div class="info" matTooltip="{{ getdocumentName(history.documentName) }}.{{history.fileType}}">
                  <h4 (click)="openDocumentViewer(true,history)" >
                    {{ getdocumentName(history.documentName) }}.{{history.fileType}}
                    <!-- {{history.documentName}}.{{history.fileType}} -->
                  </h4>
                  <p *ngIf="history.createdByFirstName && history.createdByLastname && !history?.externalUploadedBy">
                    {{history.createdByFirstName}} {{history.createdByLastname}}
                    <!-- <span>{{history.createdOn+'Z' | date:'MM/dd/yyyy'}}
                      {{history.createdOn+'Z' | date:'h:mm a'}}
                    </span> -->
                  </p>
                  <p *ngIf="history.externalUploadedBy!=''">
                    {{ history.externalUploadedBy}}
                    <span *ngIf="history.createdOn!=null">{{history.createdOn+'Z' | date:'MM/dd/yyyy'}}
                      {{history.createdOn+'Z' | date:'h:mm a'}}
                    </span>
                  </p>
                  <p *ngIf="history.externalUploadedBy==''">
                    <span *ngIf="history.createdOn!=null">
                      {{history.createdOn+'Z' | date:'MM/dd/yyyy'}}
                      {{history.createdOn+'Z' | date:'h:mm a'}}
                    </span>
                  </p>
                </div>

                                    
                 <button *ngIf="(history.fileType == 'pdf' || history.fileType == '.pdf') && history.fileManagerItemID > 0" 
                   mat-icon-button matTooltipClass="tooltip" (click)="showBindingFieldDetail(history)">
                   <mat-icon>AI</mat-icon>
                 </button>

                <button mat-icon-button (click)="DownloadSigleFile(history)">
                  <mat-icon>cloud_download</mat-icon>
                </button>

                <button mat-icon-button (click)="EditFile(myDialog,history)">
                  <mat-icon>edit</mat-icon>
                </button>

                <button *ngIf="history.pccDocumentID>0" mat-icon-button  matTooltip="Uploaded to PointClickCare">
                  <mat-icon  style="color: #0ef40e;">cloud_done</mat-icon>
                </button>
                
              </div>

            </div>
            <div *ngIf="uploadHistory.length==0 && placeholderType==2">
              <p>These forms have not been filled out yet.</p>
            </div>
          </div>
          
        <div *ngIf="participantList?.length > 0" class="proInfo" >
          <div class="title">
            <h3>Participant</h3>
          </div>
          <div class="" *ngFor="let g of participantList; let i = index">
            <mat-accordion class="contacts">    
              <mat-expansion-panel [expanded]=expand (click)="togglePanels(i)">      
                <mat-expansion-panel-header>    
                  <mat-panel-title>          
                    {{g.groupName}}          
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngFor="let p of g.getProjectGroupRelationParticipantMappingModelList; let in = index" class="bcard">
                  <div class="picinfo">
                    <div class="userpic" *ngIf="p.participantImageURL">
                      <img [src]="p.participantImageURL" alt=""/>
                    </div>
                    <div class="userpic" *ngIf="!p.participantImageURL">
                      <span class="shortName" *ngIf="p.participantName">{{getShortName(p.participantName)}}</span>
                      <span class="shortName" *ngIf="p.contactEmail">{{getShortName(p.contactEmail)}}</span>
                      <!-- <span class="shortName" *ngIf="p.contactID==0">{{getShortName(p.contactEmail)}}</span> -->
                      <span class="shortName" *ngIf="p.roleName">{{getShortName(p.roleName)}}</span>
                    </div>
                    
                    <div class="info">
                          <h4>{{p.participantName|titlecase}} <mat-icon matTooltip="Approver" *ngIf="p.isApprover==true">check_circle_outline</mat-icon></h4>                   
                        <div class="emails">
                          <div class="currentEmail" *ngIf="!p.enableEmailEdit">
                            <span *ngIf="p.participantEmail!='' && p.contactEmail!=''&& p.participantEmail!=undefined && p.contactEmail!=undefined && p.participantEmail!=null && p.contactEmail!=null">
                              {{p.contactEmail}}
                            </span>
                            <span *ngIf="p.participantEmail=='' || p.participantEmail==undefined ||  p.participantEmail==null ">
                              {{p.contactEmail}}
                            </span>
                            <span *ngIf="p.contactEmail=='' || p.contactEmail==undefined ||  p.contactEmail==null ">
                              {{p.participantEmail}}
                            </span>
                             <button mat-icon-button  color="primary" (click)="(editEmail(p,true))" ><mat-icon>create</mat-icon></button>
                          </div>
                          <div class="updateEmail currentEmail" *ngIf="p.enableEmailEdit">                  
                            <input  type="text" placeholder="Add Email" ([ngModel])="updatedParticpantEmail" (blur)="EditParticipantEmail(p,$event)">
                            <button mat-icon-button color="primary" (click)="(editEmail(p,false))" ><mat-icon>check</mat-icon></button>
                          </div>
                        
                        </div>       
                    </div>
                  </div>


                  <div class="chipsAndReminder">

                    <div class="chips">
                      <mat-chip-list aria-label="">
                        <div class="Colrd"
                        [ngStyle]="{'background-color': p.colourCode }">
                         <mat-icon *ngIf="p.typeOfParticipant==0">email</mat-icon>
                         <mat-icon *ngIf="p.typeOfParticipant==4">person</mat-icon>
                         <mat-icon *ngIf="p.typeOfParticipant==5">work</mat-icon>
                         <mat-icon *ngIf="p.typeOfParticipant==1">app_registration</mat-icon>
                         <mat-icon *ngIf="p.typeOfParticipant==2">contact_mail</mat-icon>
                         <mat-icon *ngIf="p.typeOfParticipant==3">business</mat-icon>
                        </div>                       
                        <mat-chip>{{p.relationName}} </mat-chip>
                      </mat-chip-list>   

                    </div>
                   

                    <div class="sendReminder" >
                      <a mat-icon-button matTooltip="Show Signing Page" *ngIf="g.groupName!=='Send Final Copy'" matTooltipShowDelay="1500" matTooltipClass="tooltip" 
                        href="{{p.signingToken}}" target="_blank"><mat-icon>preview</mat-icon></a>
                      <button *ngIf="g.groupName!=='Send Final Copy' && g.groupName!=='View Only' && p.hasCompleted!=true" mat-icon-button matTooltip="Send Reminder"
                       matTooltipShowDelay="1500" matTooltipClass="tooltip" 
                       (click)="ResendEmail(p)" color="basic" ><mat-icon>notifications_active</mat-icon> 
                      </button>
                      <button *ngIf="p.hasCompleted==true && p.hasCompleted!=null && g.groupName!=='Send Final Copy' && g.groupName!=='View Only'" mat-icon-button matTooltip="Reopen Signing Link" matTooltipShowDelay="1500" matTooltipClass="tooltip" (click)="ReopenSignatureLink(p)" color="basic" ><mat-icon>lock_open</mat-icon> </button>
                      <button  mat-icon-button matTooltip="Delete Participant" matTooltipShowDelay="1500" matTooltipClass="tooltip" (click)="deleteParticipant(p)" color="basic" ><mat-icon>delete_outline</mat-icon> </button>
                    </div>


                  </div>

                  <div class="allStatus">
                    <!-- <ng-container *ngIf="p.contactID!=0">
                      <div class="proStatus"
                      *ngIf="p.isEmailSent==true && p.hasCompleted==null  && p.hasViewed==null && (p.participantEmail!=null && p.participantEmail!='')">                    
                        <div class="nameIcon">
                          <mat-icon>forward_to_inbox</mat-icon> Mail Sent
                        </div>
                        <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
                          {{p.updatedOn+'Z' | date:'h:mm a'}}
                        </span>
                      </div>
          
                      <div class="proStatus" *ngIf="p.isEmailSent==false && p.hasCompleted==null && p.hasViewed==null && (p.participantEmail!=null && p.participantEmail!='')">
                        <div class="nameIcon">
                          <mat-icon>mail_outline</mat-icon> Mail Not Sent
                        </div>
                        <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
                          {{p.updatedOn+'Z' | date:'h:mm a'}}
                        </span>
                      </div>
          
                      <div class="proStatus" *ngIf="p.hasCompleted==null&& p.hasViewed==true && p.isEmailSent==true && (p.participantEmail!=null && p.participantEmail!='')">
                        <div class="nameIcon">
                          <mat-icon>check_circle_outline</mat-icon>Viewed
                        </div>   
                        <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
                          {{p.updatedOn+'Z' | date:'h:mm a'}}
                        </span>                                       
                      </div>
          
                      <div class="proStatus" *ngIf="p.hasCompleted==true && p.hasCompleted!=null && p.hasViewed==true && p.isEmailSent==true && p.rejectionMessage==null && (p.participantEmail!=null && p.participantEmail!='')">
                        <div class="nameIcon">
                          <mat-icon>check_circle_outline</mat-icon>Signed 
                        </div>  
                        <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
                          {{p.updatedOn+'Z' | date:'h:mm a'}}
                        </span>                                      
                      </div>
          
                      <div class="proStatus" *ngIf="p.hasCompleted==true && p.hasCompleted!=null && p.hasViewed==true && p.isEmailSent==true && p.rejectionMessage!=null && (p.participantEmail!=null && p.participantEmail!='')">                    
                        <div class="nameIcon">
                          <mat-icon>thumb_down_off_alt</mat-icon>Declined
                        </div>
                        <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
                          {{p.updatedOn+'Z' | date:'h:mm a'}}
                        </span>
                      </div>                
                    </ng-container> -->
          
                    <ng-container>
                      <div class="proStatus" *ngIf="p.isEmailSent==true && p.hasCompleted==null  && p.hasViewed==null">
                        <div class="nameIcon">
                          <mat-icon>forward_to_inbox</mat-icon> Sent
                        </div>
                                        
                          <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
                            {{p.updatedOn+'Z' | date:'h:mm a'}}
                          </span>                     
                        
                      </div>
                      <div class="proStatus" *ngIf="p.hasCompleted==null&& p.hasViewed==true && p.isEmailSent==true">
                        <div class="nameIcon">
                          <mat-icon>check_circle_outline</mat-icon>Viewed
                        </div> 
                        <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
                          {{p.updatedOn+'Z' | date:'h:mm a'}}
                        </span>                       
                      </div>
                      <div class="proStatus" *ngIf="p.isEmailSent==false && p.hasCompleted==null  && p.hasViewed==null">
                        <div class="nameIcon">
                          <mat-icon>mail_outline</mat-icon> Not  Sent
                        </div>
                        <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
                          {{p.updatedOn+'Z' | date:'h:mm a'}}
                        </span>                      
                      </div>
                      <div class="proStatus" *ngIf="p.hasCompleted==true && p.hasCompleted!=null && p.hasViewed==true && p.isEmailSent==true && p.rejectionMessage==null && p.isApprover==false">
                        <div class="nameIcon">
                          <mat-icon>check_circle_outline</mat-icon>Signed 
                        </div>  
                        <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
                          {{p.updatedOn+'Z' | date:'h:mm a'}}
                        </span>                      
                      </div>
          
                      <div class="proStatus" *ngIf="p.hasCompleted==true && p.hasCompleted!=null && p.hasViewed==true && p.isEmailSent==true && p.rejectionMessage!=null">                    
                        <div class="nameIcon">
                          <mat-icon>thumb_down_off_alt</mat-icon>Declined
                        </div>
                        <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
                          {{p.updatedOn+'Z' | date:'h:mm a'}}
                        </span>
                      </div>      
                      
                       <div class="proStatus" *ngIf="p.hasCompleted==true && p.isApprover==true">                    
                        <div class="nameIcon">
                          <mat-icon>check_box</mat-icon>Approved
                        </div>
                        <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
                          {{p.updatedOn+'Z' | date:'h:mm a'}}
                        </span>
                      </div>      

                    </ng-container>

                    <!-- <ng-container *ngIf="p.coreID!=0">
                      <div class="proStatus"
                      *ngIf="p.isEmailSent==true && p.hasCompleted==null  && p.hasViewed==null && (p.participantEmail!=null && p.participantEmail!='')">                    
                        <div class="nameIcon">
                          <mat-icon>forward_to_inbox</mat-icon> Mail Sent
                        </div>
                        <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
                          {{p.updatedOn+'Z' | date:'h:mm a'}}
                        </span>
                      </div>
          
                      <div class="proStatus" *ngIf="p.isEmailSent==false && p.hasCompleted==null && p.hasViewed==null && (p.participantEmail!=null && p.participantEmail!='')">
                        <div class="nameIcon">
                          <mat-icon>mail_outline</mat-icon> Mail Not Sent
                        </div>
                        <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
                          {{p.updatedOn+'Z' | date:'h:mm a'}}
                        </span>
                      </div>
          
                      <div class="proStatus" *ngIf="p.hasCompleted==null&& p.hasViewed==true && p.isEmailSent==true && (p.participantEmail!=null && p.participantEmail!='')">
                        <div class="nameIcon">
                          <mat-icon>check_circle_outline</mat-icon>Viewed
                        </div>  
                        <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
                          {{p.updatedOn+'Z' | date:'h:mm a'}}
                        </span>                                        
                      </div>
          
                      <div class="proStatus" *ngIf="p.hasCompleted==true && p.hasCompleted!=null && p.hasViewed==true && p.isEmailSent==true && p.rejectionMessage==null && (p.participantEmail!=null && p.participantEmail!='')">
                        <div class="nameIcon">
                          <mat-icon>check_circle_outline</mat-icon>Signed 
                        </div> 
                        <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
                          {{p.updatedOn+'Z' | date:'h:mm a'}}
                        </span>                                       
                      </div>
          
                      <div class="proStatus" *ngIf="p.hasCompleted==true && p.hasCompleted!=null && p.hasViewed==true && p.isEmailSent==true && p.rejectionMessage!=null && (p.participantEmail!=null && p.participantEmail!='')">                    
                        <div class="nameIcon">
                          <mat-icon>thumb_down_off_alt</mat-icon>Declined
                        </div>
                        <span *ngIf="p.updatedOn!=null">{{p.updatedOn+'Z' | date:'MM/dd/yyyy'}}
                          {{p.updatedOn+'Z' | date:'h:mm a'}}
                        </span>
                      </div>                
                    </ng-container> -->

                     


                  </div>
                  <span class="rejectMessage" *ngIf="p.rejectionMessage!=null">Rejection Message : {{p.rejectionMessage}}</span>
              </div>
              </mat-expansion-panel>
            </mat-accordion>
            </div>
        </div>


        <ng-container *ngIf="formType!=3">       
        <div class="docactions"  *ngIf="projectName==''">
          <p>Project Not Created Yet.</p> 
        </div>
       </ng-container>

         
          <div *ngIf="placeholderType!=2 " form [formGroup]="RequiredForm" class="docactions">
            Required
         <mat-slide-toggle color="primary" (change)="onChangeDocumentRequired(RequiredForm.value)" formControlName="isRequired"></mat-slide-toggle>
         </div>



          <form class="docactions" *ngIf="placeholderType!=2 && formType!=3" [formGroup]="StatusCategoryForm">
            <mat-form-field>
              <mat-label>Approval</mat-label>
              <mat-select [disabled]='!isReviewer' [(ngModel)]="documentStatus" formControlName="status" (selectionChange)="onChangeDocumentStatus($event)">                
                <mat-option *ngFor="let status of StatusCategory" [value]="status.id">
                  {{status.name}}
                </mat-option>
              </mat-select> 
            </mat-form-field>
          </form>  
         

          <div class="reviewrs" *ngIf="docReviewerList.length>0 && placeholderType!=2">
            <h3>Reviewer's List</h3>
            <div class="holdHistory">
              <div *ngIf=showAcceptedby class="hist">
                <span class="dot" ></span>
                <div class="pic"> 
                  <span class="shortName">{{AcceptedbyFirstName | slice:0:1 }}{{AcceptedbyLastName | slice:0:1}}</span> 
                </div>
                <span *ngIf="documentStatus ==2">Accepted By : {{AcceptedbyFirstName|titlecase}} {{AcceptedbyLastName|titlecase}}.</span>
                <span *ngIf="documentStatus ==3">Rejected By : {{AcceptedbyFirstName|titlecase}} {{AcceptedbyLastName|titlecase}}.</span>
            
                <span class="time" >{{documentdetail.statusChangedOn| date:'MM/dd/yyyy' }} </span>
              </div>
              
            <ng-container *ngIf='docReviewerListTop2.length>0 && showTopTwoReviewer'>
              
              <div *ngFor='let a of docReviewerListTop2;let i=index' class="hist">
                <span class="dot" ></span>
                <div class="pic"> 
                  <span class="shortName">{{a.sn}}</span> 
                </div>
                <span *ngIf='a.roleID==0'> {{a.userName}} added as reviewer.</span>
                <span *ngIf='a.roleID>0'> {{a.userName}} role added as reviewer.</span>
              </div>
            </ng-container>
            <ng-container *ngIf='docReviewerList.length>0 && docReviewerListTop2.length==0'>
              
              <div *ngFor='let a of docReviewerList;let i=index' class="hist">
                <span class="dot" ></span>
                <div class="pic"> 
                  <span class="shortName">{{a.sn}}</span> 
                </div>
                <span *ngIf='a.roleID==0'> {{a.userName}} added as reviewer.</span>
                <span *ngIf='a.roleID>0'> {{a.userName}} role added as reviewer.</span>
              </div>
            </ng-container>
            <ng-container *ngIf='docReviewerList.length>0 && !showTopTwoReviewer'>
              
              <div *ngFor='let a of docReviewerList;let i=index' class="hist">
                <span class="dot" ></span>
                <div class="pic"> 
                  <span class="shortName">{{a.sn}}</span> 
                </div>
                <span *ngIf='a.roleID==0'> {{a.userName}} added as reviewer.</span>
                <span *ngIf='a.roleID>0'> {{a.userName}} role added as reviewer.</span>
              </div>
            </ng-container>

            
          </div>
            <div class="showMore">
              <button mat-button color="primary" *ngIf='showTopTwoReviewer && docReviewerListTop2.length>0' (click)='ShowReviwers(false)'>Show More ({{docReviewerList.length+(showAcceptedby==true?1:0)}})</button>
              <button mat-button color="primary" *ngIf='!showTopTwoReviewer && docReviewerListTop2.length>0' (click)='ShowReviwers(true)'>Show Less</button>
            </div>
          </div>

            <div class="placeholder">

            <!-- <mat-form-field class="" appearance="outline" >
              <mat-label>Saved URL</mat-label>
              <input id="clipboard-example-textarea" matInput placeholder="" 
              value="{{urlforPlaceholder}}" 
              (blur)="onFormURLChange($event.target.value)"
              >
            </mat-form-field> -->
            
            <label>Saved URL</label>

            <div class="inputHolder">
  <input type="text"  placeholder="" value="{{urlforPlaceholder}}" (blur)="onFormURLChange($event.target.value)"  />

            <button mat-icon-button color="primary" [cdkCopyToClipboard]="urlforPlaceholder" > <mat-icon>content_copy</mat-icon> </button>
            <button mat-icon-button color="primary" (click)="openSavedURL()" > <mat-icon>open_in_new</mat-icon> </button>
  
            </div>
          
          </div>  
         

        
      </div>
      </mat-tab>

      <mat-tab label="Activity">

        <div class="touches_holder">
          <div class="detail">
            <div class="history">
              <div class="title">               
                <div class="head">
                  <h3>Add Activity</h3>                  
                </div>               
                <button mat-icon-button color="primary" (click)="addTouch()" [ngClass]="{'active':  addNote }">
                  <mat-icon>add</mat-icon>
                </button>
              </div>           

              <div class="historylist">
                <mat-card class="touches" *ngFor="let touch of AllCoreTouchesList">

                  <!-- Edit & Delete not ever implemented here just add below function to make that edit or delete-->
                  <!-- (editTouchEmmitter)="editTouch($event)"
                  (deleteTouchEmmitter)="deleteTouch($event)"      -->
                  <app-touches-list [touch]="touch" ></app-touches-list>
                </mat-card>
              
              </div>
            </div>

          </div>
        </div>

      </mat-tab>

    </mat-tab-group>
  </div>
</mat-card>

<div class="documentOverlay" (click)="closedocumentDetail(closeDetail)"></div>




<ng-template #signature>
  <h2 mat-dialog-title>Add Signature</h2>
  <mat-dialog-content class="mat-typography">

    <div class="signaturePanel">
      <div class="left_pannel">
        <div class="esign">
          <mat-accordion>
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Participants & Groups
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="panel">
                <div class="search">
                  <mat-form-field class="example-form-field">
                    <mat-label>Search and add participant </mat-label>
                    <input matInput type="text" />

                    <button mat-button matSuffix mat-icon-button aria-label="Clear">
                      <mat-icon>search</mat-icon>
                    </button>
                  </mat-form-field>
                </div>

                <div class="addparticipant">
                  <h3>Participants Order</h3>
                  <div class="addremove">
                    <button mat-icon-button color="primary">
                      <mat-icon>remove</mat-icon>
                    </button>
                    <button mat-icon-button color="primary">
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
                </div>

                <div cdkDropList #todoList="cdkDropList" [cdkDropListData]="todo" [cdkDropListConnectedTo]="[doneList]"
                  class="group1" (cdkDropListDropped)="drop($event)">
                  <h2>Group 1</h2>
                  <div class="moveblock" *ngFor="let item of todo" cdkDrag>
                    <span>
                      <mat-checkbox color="{{item.color}}"></mat-checkbox>
                      {{ item.role }}
                    </span>

                    <span class="text-grey">
                      <button mat-icon-button (click)="assignUser(addAssigne)">
                        <mat-icon>person_add_alt_1</mat-icon>
                      </button>
                      <button mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                    </span>
                  </div>
                </div>
                <mat-menu #menu="matMenu" xPosition="before">
                  <button mat-menu-item>Assign</button>
                  <button mat-menu-item>Unassign</button>
                  <button mat-menu-item>Delete</button>
                </mat-menu>

                <div class="group1 final">
                  <h2>Send Final Copy</h2>

                  <div cdkDropList #doneList="cdkDropList" [cdkDropListData]="done"
                    [cdkDropListConnectedTo]="[todoList]" class="getfinal" (cdkDropListDropped)="drop($event)">

                    <div class="moveblock" *ngFor="let item of done" cdkDrag>
                      <span>
                        <mat-checkbox color="{{item.color}}"></mat-checkbox>
                        {{item.role}}
                      </span>

                      <span class="text-grey">
                        <button mat-icon-button (click)="assignUser(addAssigne)">
                          <mat-icon>person_add_alt_1</mat-icon>
                        </button>
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>


                <div class="group1 mt-10">
                  <h2>Non-Participant </h2>

                  <div cdkDropList #doneList="cdkDropList" [cdkDropListData]="done"
                    [cdkDropListConnectedTo]="[todoList]" class="getfinal" (cdkDropListDropped)="drop($event)">

                  </div>
                </div>

              </div>
            </mat-expansion-panel>


          </mat-accordion>
        </div>
      </div>
      <div class="viewer">
        <embed src="../../../../../assets/Residential_Lease.pdf" type="application/pdf" width="100%" height="100%">
      </div>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button color="basic">Cancel</button>
    <button mat-button color="primary">Send</button>
  </mat-dialog-actions>

</ng-template>




<ng-template #addAssigne>

  <div class="head">
    <h2 matDialogTitle>Assign User</h2>
    <button mat-icon-button color="basic" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <form class="assign">
      <app-contactlist></app-contactlist>

    </form>

  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="close()">Cancel</button>
    <button mat-button color="primary">Assign</button>
  </mat-dialog-actions>
</ng-template>



<ng-template #myDialog>
  <form  [formGroup]="formDialog">
  <h2 mat-dialog-title>
      Edit Document Name
      <button mat-icon-button (click)="closeEditDoc()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
      <mat-label>Document Name</mat-label>
      <input matInput [required]="true"  placeholder="add document name" formControlName="documentName" 
       [(ngModel)]="fileNameEdit" />
      <mat-error
      *ngIf="formDialog.get('documentName').invalid &&
        (formDialog.get('documentName').dirty ||
        formDialog.get('documentName').touched)">
      <span>This field is mandatory.</span>
    </mat-error>
    </mat-form-field>     

</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="closeEditDoc()">Cancel</button>
  <button mat-flat-button color="primary" 
  [disabled]="formDialog.invalid || !formDialog.dirty"   
  (click)="renameDocument()">
    Update
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
</mat-dialog-actions>
<app-loader></app-loader>
</form>
</ng-template>